/* eslint-disable */
import axiosIns from '@/libs/axios'
import getCurrentDomain from '@/utils/domain'

/**
 * Real Game API Service
 * Handles all real API calls for game-related data
 */
export const gameAPI = {
  /**
   * Get slots providers from real API
   * @param {string} type - Provider type to filter (e.g., "SLOT")
   * @returns {Promise} API response with slots providers data
   */
  async getGameProviders(type = 'SLOT') {
    try {
      const response = await axiosIns.post('/internal/game/provider', {
        type: type,
        domain: getCurrentDomain()
      })
      return {
        success: true,
        data: response.data
      }
    } catch (error) {
      console.error('Failed to fetch slots providers:', error)
      throw error
    }
  },

  /**
   * Get games for a specific provider
   * @param {string} provider - Provider code (e.g., "PGS", "SPG")
   * @param {string} tab - Provider type (e.g., "SLOT")
   * @returns {Promise} API response with provider games data
   */
  async getProviderGames(provider, tab) {
    try {
      const response = await axiosIns.post('/internal/game/lists', {
        provider: provider,
        tab: tab,
        domain: getCurrentDomain()
      })
      return {
        success: true,
        data: response.data
      }
    } catch (error) {
      console.error('Failed to fetch provider games:', error)
      throw error
    }
  },

  /**
   * Get homepage data from real API
   * @returns {Promise} API response with homepage games data
   */
  async getHomepageData() {
    try {
      const response = await axiosIns.post('/internal/homepage/games', {
        domain: getCurrentDomain()
      })
      return {
        success: true,
        data: response.data
      }
    } catch (error) {
      console.error('Failed to fetch homepage data:', error)
      throw error
    }
  },

  /**
   * Get fishing games from real API
   * @returns {Promise} API response with fishing games data
   */
  async getFishingGames() {
    try {
      const response = await axiosIns.post('/internal/game/list/tab', {
        tab: 'Fish'
      })
      // Extract games array from various possible response structures
      const responseData = response.data
      let games = []

      if (Array.isArray(responseData)) {
        games = responseData
      } else if (Array.isArray(responseData?.result?.data)) {
        games = responseData.result.data
      } else if (Array.isArray(responseData?.data)) {
        games = responseData.data
      } else if (Array.isArray(responseData?.result)) {
        games = responseData.result
      }

      return {
        success: true,
        data: games
      }
    } catch (error) {
      console.error('Failed to fetch fishing games:', error)
      return { success: false, data: [] }
    }
  }
}

export default gameAPI
